export default {"src":"/_next/static/media/icon-sparkles.53a4c880.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};